<div [ngClass]="{ 'pl-1 pr-1': hasPadding }">
    <span (click)="toogleFavorite()">
        <mat-icon [ngClass]="{ 'not-favorite-icon': !isFavorite, 'favorite-icon' : isFavorite }">star</mat-icon>
    </span>
</div>
